import { Controller } from "@hotwired/stimulus"

// Loads the search-results.js embed script dynamically for proposal pages
// This is needed because scripts inside turbo frames don't execute
export default class extends Controller {
  static values = {
    websiteId: String,
    container: String,
    previewToken: String,
    scriptUrl: String
  }

  connect() {
    // Delay to ensure the container element is in the DOM
    setTimeout(() => {
      this.loadScript()
    }, 100)
  }

  disconnect() {
    // Clean up any existing script when the controller disconnects
    const existingScript = document.querySelector('script[data-search-results-embed]')
    if (existingScript) {
      existingScript.remove()
    }

    // Clean up the container
    const container = document.querySelector(this.containerValue)
    if (container) {
      container.innerHTML = ''
    }
  }

  loadScript() {
    // Remove any existing search results script first
    const existingScript = document.querySelector('script[data-search-results-embed]')
    if (existingScript) {
      existingScript.remove()
    }

    const container = document.querySelector(this.containerValue)
    if (!container) {
      console.error('[Search Results Embed Controller] Container not found:', this.containerValue)
      return
    }

    console.log('[Search Results Embed Controller] Loading script for container:', this.containerValue)

    // Create and load the script with a cache-busting timestamp
    const script = document.createElement('script')
    const timestamp = Date.now()
    script.src = `${this.scriptUrlValue}?_=${timestamp}`
    script.dataset.websiteId = this.websiteIdValue
    script.dataset.container = this.containerValue
    script.dataset.previewToken = this.previewTokenValue
    script.dataset.searchResultsEmbed = 'true'
    script.async = true

    document.body.appendChild(script)
  }
}
